import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/sterlingparker/images/logo.svg';

export default function Index() {
  return <Image src={logo} maxW="204px" position="relative" top="1.5" />;
}
